import { PUSHD_WS_URL, RPC_PING_URL, STATIC_PING_URL } from '../config/endpoints'

const PING_URLS = { rpc: RPC_PING_URL, static: STATIC_PING_URL }
const WS_URL = PUSHD_WS_URL
const ATTEMPTS = 3
const TIMEOUT_MS = 5000

const TIMEOUT_TAG = 'timeout'
const FAIL_TAG = 'fail'

function elapsedSeconds(startMs) {
  return ((performance.now() - startMs) / 1000).toFixed(3)
}

function timedGifLoad(url, timeout = TIMEOUT_MS) {
  return new Promise((resolve, reject) => {
    const start = performance.now()
    const img = new Image()

    const timer = setTimeout(() => {
      img.onerror = null
      reject(new Error(TIMEOUT_TAG))
    }, timeout)

    img.onload = () => {
      clearTimeout(timer)
      resolve(elapsedSeconds(start))
    }
    img.onerror = () => {
      clearTimeout(timer)
      reject(new Error(FAIL_TAG))
    }

    img.src = `${url}?cache_buster=${Date.now()}_${Math.random().toString(36).substring(2)}`
  })
}

function timedWsConnect(url, timeout = TIMEOUT_MS) {
  return new Promise((resolve, reject) => {
    const start = performance.now()
    const socket = new WebSocket(url)

    const timer = setTimeout(() => {
      socket.close()
      reject(new Error(TIMEOUT_TAG))
    }, timeout)

    socket.onopen = () => {
      clearTimeout(timer)
      const t = elapsedSeconds(start)
      socket.close()
      resolve(t)
    }
    socket.onerror = () => {
      clearTimeout(timer)
      reject(new Error(FAIL_TAG))
    }
  })
}

async function collectSamples(operation, attempts = ATTEMPTS) {
  const samples = []
  for (let i = 0; i < attempts; i++) {
    try {
      samples.push(await operation())
    } catch (err) {
      samples.push(err.message === TIMEOUT_TAG ? 'too long' : '-')
      break
    }
  }
  return samples
}

export async function measureNetwork() {
  return {
    RPC: await collectSamples(() => timedGifLoad(PING_URLS.rpc)),
    Static: await collectSamples(() => timedGifLoad(PING_URLS.static)),
    PushD: await collectSamples(() => timedWsConnect(WS_URL))
  }
}
